import React from "react";
import _ from "lodash"
import { connect } from "react-redux";
import Checkbox from "Components/common/Checkbox/Checkbox";
import Tooltip from "@/src/components/common/Elements/Tooltip/Tooltip";

@connect(store => {
    return {
        projectSettings: store.projectSettings
    };
})

class Day extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            days: {
                monday: {label: ""}
            }
        }
    }

    render() {
        const { dispatch, day, projectSettings } = this.props;
        const workingDays = _.omit(projectSettings.workingDays,["adjustedSetting","dateAdded", "dateUpdated","id", "projectId"])
        const dontUpdate = Object.keys(workingDays).filter(w=>{return workingDays[w]===1})

        const onChange = () => {
            if(dontUpdate.length > 1 || !day.isActive) {
                dispatch({ type: "UPDATE_SETTINGS_WORKING_DAYS", day: {[day.id]: day.isActive ? 0 : 1} })
            }
        }

        const enableToolTip = dontUpdate.length === 1;

        return (
            <div class="dayItem"   data-tooltip-id={`disableSelect-${day.label}`}>
                <Checkbox checked={day.isActive} onChange={onChange} />
                <label>{day.label}</label>

                {enableToolTip && day.isActive &&
                    <Tooltip id={`disableSelect-${day.label}`} place="bottom" effect="solid">
                    You must select at least one working day!
                    </Tooltip>
                }
            </div>
        );
    }
}

export default Day;